module.exports = __webpack_public_path__ + "img/rule-bg-ar.27370890.png";